import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { faEdit, faEye, faFilter, faPlus, faPrint } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import { mascaraOdometro, removerAcentos, removerDecimal } from '../../../../../utils'
import { Empty, Tag } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { useState } from 'react'
import { ModalFiltroAbastecimento } from '../filtro'
import dayjs from 'dayjs'
import { FiltroAvancado, filtrarAvancado } from '../filtro/meta'
import { FornecedorItens } from '../../../../../services/Fornecedores'
import { PropriedadeItens } from '../../../../../services/Propriedades'
import { Box } from '../../../../../Components/CustomUi/box'
import { mascaraOdom } from '../../../../../services/Afins'

const tags_acerto = {
    reembolso: { label: 'Reembolso', cor: 'blue' },
    desconto: { label: 'Desc. na folha', cor: 'volcano' },
    empresa: { label: 'Empresa', cor: 'green' },
}

function tipoAcerto(necessario_reembolso: boolean, desconto_folha: boolean) {
    if (necessario_reembolso) return tags_acerto.reembolso
    if (desconto_folha) return tags_acerto.desconto
    return tags_acerto.empresa
}

interface PropsTabela {
    loading: boolean
    setPagination: React.Dispatch<React.SetStateAction<number>>
    page: number
    setPage: React.Dispatch<React.SetStateAction<number>>
    total: number
    listar_abastecimento: any[]
    /**Postos e propriedades vêm da tela principal, são as mesmas listas usadas no cadastro */
    data_postos: FornecedorItens[]
    data_propriedades: PropriedadeItens[]
    abrir: Function
    permissao: ItensPerUserLogged
    editar: Function
    deletar: Function
    buscar_tabela: string
    setBuscar_tabela: React.Dispatch<React.SetStateAction<string>>
    confirmar_exclusao: boolean
    setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
    id_item_atual: number
    setId_item_atual: React.Dispatch<React.SetStateAction<number>>
    nome_item_atual: string
    setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
    fake_loading: boolean
}

export const TabelaAbastecimento: React.FC<PropsTabela> = ({
    loading,
    setPagination,
    page,
    setPage,
    total,
    listar_abastecimento,
    data_postos,
    data_propriedades,
    abrir,
    permissao,
    editar,
    deletar,
    buscar_tabela,
    setBuscar_tabela,
    confirmar_exclusao,
    setConfirmar_exclusao,
    id_item_atual,
    setId_item_atual,
    nome_item_atual,
    setNome_item_atual,
    fake_loading,
}) => {

    const [abrirModal, setAbrirModal] = useState<boolean>(false)
    /**Campos do filtro avançado, aplicados na lista somente ao clicar em `Filtrar` */
    const [filtro_aplicado, setFiltro_aplicado] = useState<FiltroAvancado>(null)
    const [tab_local, setTab_local] = useState<string>('Posto')
    const [intervalo_datas, setIntervalo_datas] = useState<any[]>([])
    const [fornecedor_selecionado, setFornecedor_selecionado] = useState<string>('')
    const [fornecedor_selecionado_id, setFornecedor_selecionado_id] = useState<number>(null)
    const [propriedade_selecionada, setPropriedade_selecionada] = useState<string>('')
    const [propriedade_selecionada_id, setPropriedade_selecionada_id] = useState<number>(null)
    const [responsavel_selecionado, setResponsavel_selecionado] = useState<string>('')
    const [responsavel_selecionado_id, setResponsavel_selecionado_id] = useState<number>(null)
    const [frota_selecionada, setFrota_selecionada] = useState<string>('')
    const [forma_pagamento, setForma_pagamento] = useState<string>('')
    const [forma_pagamento_id, setForma_pagamento_id] = useState<number>(null)
    const [reembolsados, setReembolsados] = useState<boolean>(false)
    const [descontados_folha, setDescontados_folha] = useState<boolean>(false)

    function buscarAbastecimento(buscar_nome: string) {
        const palavraSemAcentos = removerAcentos(buscar_nome)
        return function (item) {
            const nomeSemAcentos = removerAcentos(String(item?.nome))
            return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    function abrirModalFiltro() {
        setAbrirModal(true)
    }

    function fecharModalAbasFiltro() {
        setAbrirModal(false)
        setTab_local('Posto')
        setIntervalo_datas([])
        setFornecedor_selecionado('')
        setFornecedor_selecionado_id(null)
        setPropriedade_selecionada('')
        setPropriedade_selecionada_id(null)
        setResponsavel_selecionado('')
        setResponsavel_selecionado_id(null)
        setFrota_selecionada('')
        setForma_pagamento('')
        setForma_pagamento_id(null)
        setReembolsados(false)
        setDescontados_folha(false)
    }

    function filtrarAbastecimento() {
        setFiltro_aplicado({
            local: tab_local,
            intervalo_datas: intervalo_datas,
            cod_fornecedor: fornecedor_selecionado_id,
            cod_propriedade: propriedade_selecionada_id,
            cod_responsavel: responsavel_selecionado_id,
            frota: frota_selecionada,
            cod_forma_pagamento: forma_pagamento_id,
            reembolsados: reembolsados,
            descontados_folha: descontados_folha,
        })
        fecharModalAbasFiltro()
    }

    /**Lista exibida na tabela: primeiro o filtro avançado, depois a busca por nome */
    const abastecimentos_filtrados = filtrarAvancado(filtro_aplicado, listar_abastecimento)
        .filter(buscarAbastecimento(buscar_tabela))

    return (
        <Box borderless style={{ height: 'calc(100vh - 170px)' }} >
            <Inline alignItems='center'>
                <Input
                    placeholder='Buscar abastecimento'
                    value={buscar_tabela}
                    onChange={setBuscar_tabela}
                />
                <ButtonCustom icon={<FontAwesomeIcon icon={faFilter} />} type='secondary' onClick={abrirModalFiltro} >
                    Filro avançado
                </ButtonCustom>
                <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
                    Novo
                </ButtonCustom>
            </Inline>
            <HeaderTable
                itens={[
                    { valor: 'Data', width: '100.5px' },
                    { valor: 'Nome', width: 'calc(100% - 906px)' },
                    { valor: 'Veículo', width: '300px' },
                    { valor: 'Odômetro', width: '130px' },
                    { valor: 'Frota', width: '90px' },
                    { valor: 'Acerto', width: '120px' },
                    { valor: 'Ações', width: '160px' },
                ]}
            />

            <BodyTable
                paginate={total}
                onChangeItensPage={setPagination}
                onChangePage={setPage}
                current_page={page}
                setCurrent_page={setPage}
                style={{
                    height: 'calc(100vh - 270px)',
                    position: 'relative',
                    overflowX: 'hidden',
                    overflowY: 'scroll',
                    marginTop: -10,
                }}
            >
                <Render condition={!loading}>
                    {abastecimentos_filtrados
                        .map(({ cod, data, usuario_nome, veiculo_nome, odom_atual, frota, desconto_folha, necessario_reembolso }, index) => {
                            const acerto = tipoAcerto(necessario_reembolso, desconto_folha)

                            return (
                                <RowTable
                                    style={{ marginTop: index === 0 ? '10px' : '0px' }}
                                    key={cod}
                                    onDoubleClick={() => editar(cod)}
                                >
                                    <RowItem fontSize={13} width={'100px'}>
                                        {dayjs(data).format('DD/MM/YYYY')}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'calc(100% - 900px)'}>
                                        {usuario_nome}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'300px'}>
                                        {veiculo_nome}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'130px'}>
                                        {mascaraOdom(removerDecimal(odom_atual))}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'90px'}>
                                        {frota}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'120px'}>
                                        <Tag color={acerto.cor} style={{ fontWeight: 500 }}>
                                            {acerto.label}
                                        </Tag>
                                    </RowItem>

                                    <RowItem width={'160px'} gap={10}>
                                        <DeleteButton
                                            open={confirmar_exclusao && id_item_atual === cod}
                                            trigger={setConfirmar_exclusao}
                                            onTrigger={() => {
                                                setId_item_atual(cod)
                                                setNome_item_atual(usuario_nome)
                                            }}
                                            loading={fake_loading}
                                            message={`o item ${usuario_nome} será excluido!`}
                                            deleteds={[usuario_nome]}
                                            onDelete={() => {
                                                deletar(cod)
                                            }}
                                            disabled={fake_loading || permissao?.exclusao === 0}
                                            disabledTrigger={permissao?.exclusao === 0}
                                        />
                                        <ButtonCustom
                                            icon={<FontAwesomeIcon icon={(permissao?.alteracao === 0 || permissao?.inclusao === 0) ? faEye : faEdit} />}
                                            onClick={() => editar(cod)}
                                            disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                                        >
                                            {(permissao?.alteracao === 0 || permissao?.inclusao === 0) ? 'Ver' : 'Editar'}
                                        </ButtonCustom>
                                    </RowItem>
                                </RowTable>
                            )
                        })}
                </Render>

                <Render condition={abastecimentos_filtrados.length === 0 && !loading}>
                    {buscar_tabela === '' ? (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={<> Nenhum registro disponível!</>}
                        />
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <>
                                    {' '}
                                    <b>'{buscar_tabela}'</b> não encontrado!
                                </>
                            }
                        />
                    )}
                </Render>

                <Render condition={loading}>
                    <Carregando
                        animation
                        legenda='Carregando abastecimentos...'
                        justifyContent='center'
                        height={200}
                        size='default'
                    />
                </Render>
            </BodyTable>
            <ModalFiltroAbastecimento
                abrirModal={abrirModal}
                fecharModal={fecharModalAbasFiltro}
                listar_abastecimento={listar_abastecimento}
                data_postos={data_postos}
                data_propriedades={data_propriedades}
                tab_local={tab_local}
                setTab_local={setTab_local}
                intervalo_datas={intervalo_datas}
                setIntervalo_datas={setIntervalo_datas}
                fornecedor_selecionado={fornecedor_selecionado}
                setFornecedor_selecionado={setFornecedor_selecionado}
                setFornecedor_selecionado_id={setFornecedor_selecionado_id}
                propriedade_selecionada={propriedade_selecionada}
                setPropriedade_selecionada={setPropriedade_selecionada}
                setPropriedade_selecionada_id={setPropriedade_selecionada_id}
                responsavel_selecionado={responsavel_selecionado}
                setResponsavel_selecionado={setResponsavel_selecionado}
                setResponsavel_selecionado_id={setResponsavel_selecionado_id}
                frota_selecionada={frota_selecionada}
                setFrota_selecionada={setFrota_selecionada}
                forma_pagamento={forma_pagamento}
                setForma_pagamento={setForma_pagamento}
                setForma_pagamento_id={setForma_pagamento_id}
                reembolsados={reembolsados}
                setReembolsados={setReembolsados}
                descontados_folha={descontados_folha}
                setDescontados_folha={setDescontados_folha}
                filtrarAbastecimento={filtrarAbastecimento}
            />
        </Box>
    )
}
